import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { FaBars } from 'react-icons/fa'; // Import the icons

const ChatComponent = () => {
    const location = useLocation();
    const { selectedHCW } = location.state || {};

    const [inputValue, setInputValue] = useState('');
    const [messages, setMessages] = useState([]);
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const ws = useRef(null); // for websocket???
    const ws_url = process.env.REACT_APP_WS_URL;

    useEffect(() => {
        ws.current = new WebSocket(`${ws_url}/chat/ws/3?`);

        ws.current.onopen = () => {
            console.log('WebSocket connection established');
        };

        ws.current.onmessage = (event) => {
            const data = JSON.parse(event.data);
            setMessages((prevMessages) => [
                ...prevMessages,
                { type: 'other', text: `${data.sender}: ${data.text}` },
            ]);
        };

        ws.current.onclose = () => {
            console.log('WebSocket connection closed');
        };

        ws.current.onerror = (error) => {
            console.error('WebSocket error:', error);
        };

        return () => {
            ws.current.close();
        };
    }, []);

    const handleSend = () => {
        if (inputValue.trim() === '') return;

        // const messageData = {
        //     sender: 'placeholderName',
        //     text: inputValue,
        // };

        // Send through WebSocket now
        ws.current.send(inputValue);

        setMessages((prevMessages) => [
            ...prevMessages,
            { type: 'user', text: inputValue },
            // { type: 'bot', text: getResponse(inputValue) },
        ]);
        setInputValue('');
    };

    // Check if selectedHCW is defined
    if (!selectedHCW) {
        return <h2>No healthcare worker selected.</h2>;
    }

    // const getResponse = (input) => {
    //     if (input.toLowerCase().includes('hello')) {
    //         return 'Hi there! How can I help you?';
    //     } else if (input.toLowerCase().includes('help')) {
    //         return 'Sure! What do you need help with?';
    //     } else {
    //         return "I'm not sure about that. Can you ask something else?";
    //     }
    // };

    return (
        <div style={ChatComponent.container}>
            <div style={ChatComponent.header}>
                <h2 style={ChatComponent.headerText}>
                    Chat with {selectedHCW.first_name} {selectedHCW.last_name}
                </h2>
                <button
                    onClick={() => setDropdownVisible(!dropdownVisible)}
                    style={ChatComponent.toggleButton}
                >
                    <FaBars /> {/* Use a sidebar icon */}
                </button>
            </div>

            {/* Dropdown Menu */}
            {dropdownVisible && (
                <div style={ChatComponent.dropdownMenu}>
                    <button
                        onClick={() => {
                            /* Handle Logout */
                        }}
                        style={ChatComponent.dropdownItem}
                    >
                        Logout
                    </button>
                </div>
            )}

            {/* Chat Messages */}
            <div style={ChatComponent.chatContainer}>
                {messages.map((message, index) => (
                    <div
                        key={index}
                        style={{
                            ...ChatComponent.bubble,
                            ...(message.type === 'user'
                                ? ChatComponent.userBubble
                                : ChatComponent.botBubble),
                        }}
                    >
                        <p style={ChatComponent.bubbleText}>{message.text}</p>
                    </div>
                ))}
            </div>

            {/* Input Area */}
            <div style={ChatComponent.inputContainer}>
                <input
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="Type a message..."
                    style={ChatComponent.input}
                />
                <button onClick={handleSend} style={ChatComponent.sendButton}>
                    Send
                </button>
            </div>
        </div>
    );
};

export default ChatComponent;
